// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__2PzXQ","normalXl":"styles_normalXl__oXSXe","normalLg":"styles_normalLg__MDCJX","normalMd":"styles_normalMd__JG4g8","normalSm":"styles_normalSm__bS35c"};